import { Identifiable, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = void;

function deleteZone(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Zone>) =>
    new Promise<void>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Response>({
          endpoint: `/zones/${uuid}`,
          method: HttpMethods.DELETE,
        })
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { deleteZone };
